import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { BffClient } from '@redbax/shared';

const AdminBffClientContext = React.createContext<BffClient | null>(null);

export function AdminBffClientProvider({ children }: { children: React.ReactNode }) {
  const { getToken } = useAuth();

  const baseUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_BFF_BASE_URL as string) || '';

  const client = React.useMemo(
    () => new BffClient(getToken, () => null, baseUrl),
    [getToken, baseUrl],
  );

  return React.createElement(AdminBffClientContext.Provider, { value: client }, children);
}

export function useAdminBffClient(): BffClient {
  const client = React.useContext(AdminBffClientContext);
  if (!client) {
    throw new Error('useAdminBffClient must be used within an AdminBffClientProvider');
  }
  return client;
}
